import React from 'react'
import { selectedMappingId } from 'Pages/User/CustomMapping/@signals'
import { DrawerSeeker } from '@ui-seeker/core'
import MappingDrawerFooter from 'Pages/User/CustomMapping/EditDrawer/Footer'
import MappingDrawerContent from 'Pages/User/CustomMapping/EditDrawer/Content'
import { isEmpty } from '@ui-seeker/utils'
import { batch, useComputed } from '@preact/signals-react'
import MappingDrawerTitle from 'Pages/User/CustomMapping/EditDrawer/Title'
import { formData } from '@signals'

export default function EditMappingDrawer() {

	const isDataEmpty = useComputed(() => isEmpty(formData.value))

	if (isDataEmpty.value) return null

	return <DrawerSeeker
		isOpen={!isDataEmpty.value}
		controller={() => batch(() => {
			formData.value = {}
			selectedMappingId.value = null
		})}
		title={<MappingDrawerTitle/>}
		customFooter={<MappingDrawerFooter/>}
	>
		<MappingDrawerContent/>
	</DrawerSeeker>

}